export type CustomFieldFormWidth = 'half' | 'full';

export function customFieldUsesFullWidth(field: {
  type: string;
  optionsLayout?: string | null;
  formWidth?: CustomFieldFormWidth | null;
}): boolean {
  if (field.formWidth === 'full') return true;
  if (field.formWidth === 'half') return false;
  return (
    field.type === 'textarea' ||
    field.type === 'file' ||
    field.type === 'image' ||
    (field.type === 'multiselect' && field.optionsLayout === 'horizontal')
  );
}

export function customFieldFormSpan(
  field: {
    type: string;
    optionsLayout?: string | null;
    formWidth?: CustomFieldFormWidth | null;
  },
  wide: 'md' | 'lg',
): string | undefined {
  if (!customFieldUsesFullWidth(field)) return undefined;
  return wide === 'md' ? 'md:col-span-2' : 'lg:col-span-2';
}

export function compareCustomFieldOrder(
  a: { sortOrder?: number | null; name: string; groupName?: string | null },
  b: { sortOrder?: number | null; name: string; groupName?: string | null },
): number {
  const order = (a.sortOrder ?? 0) - (b.sortOrder ?? 0);
  if (order !== 0) return order;
  const group = (a.groupName ?? '').localeCompare(b.groupName ?? '', 'es');
  if (group !== 0) return group;
  return a.name.localeCompare(b.name, 'es');
}
